import { Injectable, inject } from '@angular/core';
import { AuthService } from '../services/implements/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private readonly authService = inject(AuthService);

  canActivate(): boolean {
    const isLoggedIn = this.authService.isLoggedIn();
    if (!isLoggedIn) {
      this.authService.logout();
    }
    return isLoggedIn;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }
}
